import type {
  BackgroundInsetSize,
  BackgroundSpacing,
  BackgroundVerticalAlign,
  BackgroundWidth,
  BlockAlign,
} from './types';

export const DEFAULT_BACKGROUND_COLOR = '#ffffff';

export const blockAlignOptions: BlockAlign[] = ['start', 'center', 'end'];
export const spacingOptions: BackgroundSpacing[] = ['none', 'sm', 'md', 'lg'];
export const alignmentOptions: BackgroundVerticalAlign[] = ['top', 'center', 'bottom'];
export const insetSizeOptions: BackgroundInsetSize[] = ['sm', 'md', 'lg'];
export const backgroundWidthOptions: BackgroundWidth[] = ['fill', 'inset'];

export const optionLabelMap: Record<string, string> = {
  none: 'None',
  sm: 'S',
  md: 'M',
  lg: 'L',
  start: 'Start',
  center: 'Center',
  end: 'End',
  top: 'Top',
  bottom: 'Bottom',
  fill: 'Fill',
  inset: 'Inset',
};
